// https://github.com/ngrx-utils/ngrx-utils/blob/master/libs/store/src/lib/directives/ngLet.ts
import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

export class NgLetContext<U> {
  $implicit: any = null;
  ngLet: any = null;
}

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[ngLet]',
})
export class NgLetDirective<T> {
  private _context: NgLetContext<T> = new NgLetContext();

  @Input()
  set ngLet(value: T) {
    this._context.$implicit = this._context.ngLet = value;
  }

  constructor(
    viewContainer: ViewContainerRef,
    templateRef: TemplateRef<NgLetContext<T>>
  ) {
    viewContainer.createEmbeddedView(templateRef, this._context);
  }
}
